import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { useEffect, useRef, useState } from "react";

import { withRouter } from "../../shared/utility";

import SideNavigationBar from "../../components/sideNavigationBar/SideNavigationBar";
import HeaderLayout from "./HeaderLayout";
import { Toast } from "primereact/toast";
import Schedule from "../../views/schedule/Schedule";
import WorkOrderDetails from "../../views/workOrders/WorkOrderDetails";
import { classNames } from "primereact/utils";
import CreateWorkOrder from "../../views/workOrders/CreateWorkOrder";
import MyAccount from "../../views/myAccount/MyAccount";
import WorkOrders from "../../views/workOrders/WorkOrders";

function DefaultLayout(props) {
  const { name, logout, user_type, snackbarQueue, removeSnackbar } = props;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const size = useWindowSize();
  const toast = useRef(null);

  useEffect(() => {
    snackbarQueue.forEach((snackbar) => {
      toast.current.show({
        severity: "success",
        summary: snackbar.message,
        content: null,
        life: 3000,
      });
      removeSnackbar(snackbar.id);
    });
  }, [snackbarQueue]);

  useEffect(() => {
    if (size.width < 1024) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(false);
    }
  }, [size]);

  const outsideClickRef = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        outsideClickRef.current &&
        !outsideClickRef.current.contains(event.target) &&
        size.width < 1024
      ) {
        setSidebarOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [outsideClickRef, size]);

  return (
    <div
      className={classNames(
        sidebarOpen
          ? size.width < 991
            ? "scroll-blocked layout-mobile-active"
            : ""
          : "layout-static-inactive",
        "layout-container layout-static layout-light"
      )}
    >
      <SideNavigationBar
        user_type={user_type}
        outsideClickRef={outsideClickRef}
      />
      <Toast ref={toast} />
      <div className="layout-content-wrapper">
        <div className="layout-mask"></div>
        <HeaderLayout
          sidebarOpen={sidebarOpen}
          logout={logout}
          setSidebarOpen={setSidebarOpen}
          name={name}
        />

        <Routes>
          <Route path="/schedule" element={<Schedule />} />

          <Route path="/new-work-order" element={<CreateWorkOrder />} />
          <Route path="/work-orders/:id" element={<WorkOrderDetails />} />
          <Route path="/work-order" element={<WorkOrderDetails />} />
          <Route path="/work-orders" element={<WorkOrders />} />

          <Route path="/my-account" element={<MyAccount />} />

          <Route path="*" element={<Navigate to="/schedule" replace />} />
        </Routes>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    name: state.auth.name,
    user_type: state.auth.user_type,
    snackbarQueue: state.utilities.snackbarQueue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    removeSnackbar: (snackbarId) =>
      dispatch(actions.removeSnackbar(snackbarId)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)
);

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
